import { useEffect, useState } from "react"
import '../CSS/DashboardTemp.css'
import Header from "./Header";
import Loader from "./Loader";
import Footer from "./footer";
import { NavLink } from 'react-router-dom';
import MySideBar from "./MySideBar";
import NavBar from "./NavBar";


const MyCourses = () => {
    const [isLoader, setIsLoader] = useState(true);
    setTimeout(() => {
        setIsLoader(false);
    }, 3000);

    useEffect(() => {
        if (window.location.toString().includes("/user/courses") && !isLoader) {
            document.getElementById("my-courses-sidebar-link").classList.add("active")
        }
    }, [isLoader])

    const courses = [
        { id: 1, img: "/python.jpeg", course_name: "SONY AI PYTHON - 2024" }
    ];



    return (
        <div>
            <Header />
            {isLoader ? (
                <Loader />
            ) : (
                <div className="dashboard row dark" id="dashboard">
                    <MySideBar />
                    <div id="content">
                        <NavBar isPencil={false} />

                        <div style={{margin: "30px"}}>
                            <h1 style={{marginBottom: "20px", color: "var(--dark)"}}>My Courses</h1>
                            {courses.map((img, index) => (
                                <div className="row">
                                    <NavLink to={`/course/${img.id}`} className="col-3">
                                        <div key={index} className="courses-card container">
                                            <img src={img.img} alt={`course-${index}`} />
                                            <div className="course-centered">
                                                <ul>
                                                    <li>View</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>


            )}
            <Footer />
        </div>
    )
}

export default MyCourses;